export default __webpack_public_path__ + "static/media/city-hall.21490242.svg";